import { render, staticRenderFns } from "./MolPhase1Report.vue?vue&type=template&id=889e94ee"
import script from "./MolPhase1Report.vue?vue&type=script&lang=js"
export * from "./MolPhase1Report.vue?vue&type=script&lang=js"
import style0 from "./MolPhase1Report.vue?vue&type=style&index=0&id=889e94ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports